export enum MachineSettingsSection {
  Actions = 'Actions',
  BurnInTests = 'BurnInTests', // Super admin only
  Configuration = 'Configuration',
  Errors = 'Errors', // Super admin only
  FWLogs = 'FWLogs', // Super admin only
  HwDiagnostics = 'HwDiagnostics',
  Inspect = 'Inspect',
  LiveFires = 'LiveFires', // Super admin only
  PitchReport = 'PitchReport', // Super admin only
  Plotting = 'Plotting', // Super admin only
  ServiceLogs = 'ServiceLogs', // Super admin only
  SessionHistory = 'SessionHistory',
  ShotHistory = 'ShotHistory', // Super admin only
  Status = 'Status',
  TrainingPerformance = 'TrainingPerformance', // Super admin only
}

export enum MachineSettingsQueryParams {
  MachineID = 'machineID',
  SectionID = 'section',

  ErrorID = 'errorID', // error._id, confusing but it is what it is
  ErrorTypeID = 'errorTypeID', // error.errorID (i.e. to match w/ error-types), confusing but it is what it is
  ErrorDateStart = 'errorDateStart',
  ErrorDateEnd = 'errorDateEnd',
  ErrorSlack = 'errorSlack',
  ErrorInternal = 'errorInternal',
  ErrorSender = 'errorSender',
  ErrorLevel = 'errorLevel',

  FireID = 'fireID',

  ShotID = 'shotID',
  ShotDateStart = 'shotDateStart',
  ShotDateEnd = 'shotDateEnd',
  ShotMode = 'shotMode',
  ShotConfidence = 'shotConfidence',
  ShotHasVideo = 'shotHasVideo',
  ShotPitchName = 'shotPitchName',
  ShotHitterID = 'shotHitterID',

  MissedDetectionID = 'missedDetectionID',
  MissedDetectionDateStart = 'missedDetectionDateStart',
  MissedDetectionDateEnd = 'missedDetectionDateEnd',
  MissedDetectionPitchName = 'missedDetectionPitchName',
  MissedDetectionMessage = 'missedDetectionMessage',

  HistoryTab = 'historyTab',
}

export enum HistoryTab {
  ShotHistory = 'shots',
  MissedDetections = 'missed',
}

export const MachineShotHistoryQueryParams = [
  MachineSettingsQueryParams.ShotID,
  MachineSettingsQueryParams.ShotDateStart,
  MachineSettingsQueryParams.ShotDateEnd,
  MachineSettingsQueryParams.ShotMode,
  MachineSettingsQueryParams.ShotConfidence,
  MachineSettingsQueryParams.ShotHasVideo,
  MachineSettingsQueryParams.ShotPitchName,
  MachineSettingsQueryParams.ShotHitterID,
  // we'll include missed detection params as well for the purposes of clearing them out when navigating away from the shot history section
  MachineSettingsQueryParams.MissedDetectionID,
  MachineSettingsQueryParams.MissedDetectionDateStart,
  MachineSettingsQueryParams.MissedDetectionDateEnd,
  MachineSettingsQueryParams.MissedDetectionPitchName,
  MachineSettingsQueryParams.MissedDetectionMessage,
  MachineSettingsQueryParams.HistoryTab,
];

export const MachineErrorsQueryParams = [
  MachineSettingsQueryParams.ErrorID,
  MachineSettingsQueryParams.ErrorDateStart,
  MachineSettingsQueryParams.ErrorDateEnd,
  MachineSettingsQueryParams.ErrorSlack,
  MachineSettingsQueryParams.ErrorInternal,
  MachineSettingsQueryParams.ErrorSender,
  MachineSettingsQueryParams.ErrorLevel,
];

export const MachineShotLiveFiresQueryParams = [
  MachineSettingsQueryParams.FireID,
];
